// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d519faf0","239":"aab95090","455":"846fb7de"}[chunkId] + ".chunk.js";
};